
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.8 0l-.19.657-.189.657-1.506 5.234h-3.74L9.386.436A.667.667 0 0110.01 0H12.8zM12.3 6.548l.612-2.129h4.181v2.13H12.3zM23.305 6.548h-4.88V4.42H22.7l.604 2.13zM27.988 6.548h-3.3l-1.484-5.234-.186-.657L22.831 0h2.205c.277 0 .526.17.623.426l2.329 6.122zM27.784 7.88h-4.101l-.005-.018h4.099l.007.019zM8.307 15.792l-2.534 8.894-.187.657H1.091l3.876-10.725h12.126v5.06h-8.51l1.005-3.53a.657.657 0 00-.46-.81.667.667 0 00-.82.454zM18.424 14.618h7.168l1.434 5.06h-8.602v-5.06z","fill":"#8B5CF6"}}),_c('path',{attrs:{"d":"M34.426 25.343H6.97l.187-.657 1.053-3.694h19.19l.987 3.485a.67.67 0 001.18.209.648.648 0 00.102-.564l-2.694-9.504h3.372l4.08 10.725z","fill":"#8B5CF6"}}),_c('path',{attrs:{"d":"M6.701 7.862l-.007.019h1.414l.007-.019H6.7zm21.076 0h-.71l.007.019h.71l-.007-.019zm7.273 17.25l-3.992-10.494h-1.422l3.83 10.068h-3.9a.662.662 0 01-.539.27.67.67 0 01-.539-.27H7.156l-.187.657-.187.657h27.644a.668.668 0 00.547-.283.651.651 0 00.077-.605zm-33.016-.426l3.64-10.068H4.376a.616.616 0 01-.114-.01l-3.8 10.514a.653.653 0 00.084.6.67.67 0 00.544.278h4.307l.188-.657.187-.657H2.034zM22.33 3.105h-9.04l.515-1.79.19-.658.188-.657h7.266l.186.657.187.657.507 1.79zM11.921 7.862l-.006.019h-1.383l.005-.019h1.384zM25.065 7.88h-1.382l-.005-.018h1.381l.006.019zM30.39 13.31l-25.74-.006V8.538c0-.363.299-.657.666-.657h24.415c.368 0 .666.294.666.657l-.008 4.771z","fill":"#8B5CF6"}})])
          )
        }
      }
    